// @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime"
import { useState, useEffect } from "react"
import { Dropdown } from "primereact/dropdown"

const TableMultiSelect = ({
  options,
  itemTemplate,
  onChange
}: any) => {
  const [value, setValue] = useState()
  useEffect(() => {
    if (options) {
      setValue(options.map((option: any) => option.value))
    }
  }, options)
  return _jsx(
    Dropdown,
    {
      style: { width: "100%" },
      value,
      onChange: (e: any) => {
        const values = e.value
        setValue(values)
        onChange(values)
      },
      itemTemplate,
      options,
      className: "p-column-filter",
    },
    void 0
  );
}
export default TableMultiSelect
